export default "__VITE_ASSET__wu_15ZER__"